import React from 'react';

export const FacebookSvg = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-584, -20)">
        <g transform="translate(584, 20)">
          <circle
            fill="#2E5894"
            fillRule="nonzero"
            cx="20"
            cy="20"
            r="20"
          ></circle>
          <path
            d="M22.0262775,32.5 L22.0262775,21.597903 L25.4309008,21.597903 L26.0788325,17.0619781 L22.0262775,17.0619781 L22.0262775,14.1185231 C22.0262775,12.8777338 22.5923827,11.6681368 24.4074741,11.6681368 L26.25,11.6681368 L26.25,7.80655397 C26.25,7.80655397 24.5778067,7.5 22.9792094,7.5 C19.6415025,7.5 17.4601007,9.67234009 17.4601007,13.6050005 L17.4601007,17.0619781 L13.75,17.0619781 L13.75,21.597903 L17.4601007,21.597903 L17.4601007,32.5 L22.0262775,32.5 Z"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </svg>
);
